import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { CanvasContext } from "../../../contexts/CanvasContext";
import ButtonComponent from "./ButtonComponent";
import ImageComponent from "./ImageComponent";
import HeaderComponent from "./HeaderComponent";
import ParagraphComponent from "./ParagraphComponent";
import IconComponent from "./IconComponent";
import LinkComponent from "./LinkComponent";
import CheckboxComponent from "./CheckboxComponent";
import RadioComponent from "./RadioComponent";
import ListComponent from "./ListComponent";
import TableComponent from "./TableComponent";
import VideoComponent from "./VideoComponent";
import TextInputComponent from "./TextComponent";
import RangeComponent from "./RangeComponent";
import PasswordInputComponent from "./PasswordInputComponent";
import EmailInputComponent from "./EmailInputComponent";
import NumberInputComponent from "./NumberInputComponent";
import DateInputComponent from "./DateInputComponent";
import ColorInputComponent from "./ColorInputComponent";
import FileInputComponent from "./FileInputComponent";
import AudioComponent from "./AudioComponent";
import DropDownComponent from "./DropDownComponent";
import MapComponent from "./MapComponent";
import Division from "./Division";
import HeaderTag from "./HeaderTag";
import Hgroup from "./Hgroup";
import Footer from "./Footer";
import Span from "./Span";
import FormComponent from "./FormComponent";
import MainComponent from "./MainComponent";
import ArticleComponent from "./ArticleComponent";
import AsideComponent from "./AsideComponent";
import HRTag from "./HRTag";
import BRTag from "./BRTag";
import OutputComponent from "./OutputComponent";
import IframeComponent from "./IframeComponent";
import Section from "./Section";

const Nav = ({ nav }) => {
  const NavRef = useRef(null);

  const { addElement, hoveredDivision, files, addCanvasDrop, addDivision } =
    useContext(CanvasContext);
  const isHovered = nav.id === hoveredDivision;
  const [isNavHovered, setIsNavHovered] = useState(false);
  const [isNavFocused, setIsNavFocused] = useState(false);
  const [isNavActive, setIsNavActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = nav;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = nav;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = nav;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = nav;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const generateKeyframes = () => {
    if (!nav.keyframes || nav.keyframes.length === 0) return null;

    return nav.keyframes.map((kf) => {
      const properties = {};
      let transform = "";

      Object.entries(kf.properties).forEach(([key, value]) => {
        // Remove 'KEY' prefix if present
        let processedKey = key.startsWith("KEY") ? key.slice(3) : key;

        // Handle transform properties
        if (
          processedKey === "scale" ||
          processedKey === "translateX" ||
          processedKey === "translateY" ||
          processedKey === "rotate" ||
          processedKey === "skewX" ||
          processedKey === "skewY"
        ) {
          if (value) {
            switch (processedKey) {
              case "scale":
                transform += `scale(${value}) `;
                break;
              case "translateX":
                transform += `translateX(${value}) `;
                break;
              case "translateY":
                transform += `translateY(${value}) `;
                break;
              case "rotate":
                transform += `rotate(${value}) `;
                break;
              case "skewX":
                transform += `skewX(${value}) `;
                break;
              case "skewY":
                transform += `skewY(${value}) `;
                break;
              default:
                break;
            }
          }
        } else {
          // Convert camelCase to kebab-case for other CSS properties
          properties[processedKey] = value;
        }
      });

      // Add transform property if it was built
      if (transform) {
        properties["transform"] = transform.trim();
      }

      return {
        offset: kf.position / 100,
        ...properties,
      };
    });
  };

  useEffect(() => {
    if (NavRef.current && nav.keyframes && nav.keyframes.length > 0) {
      const keyframes = generateKeyframes();
      const animation = NavRef.current.animate(keyframes, {
        duration: parseFloat(nav.animationDuration) * 1000 || 1000,
        delay: parseFloat(nav.animationDelay) * 1000 || 0,
        iterations:
          nav.animationIterationCount === "infinite"
            ? Infinity
            : parseFloat(nav.animationIterationCount) || 1,
        direction: nav.animationDirection || "normal",
        fill: nav.animationFillMode || "none",
        easing: nav.animationTimingFunction || "linear",
      });

      return () => animation.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    nav.keyframes,
    nav.animationDuration,
    nav.animationDelay,
    nav.animationIterationCount,
    nav.animationDirection,
    nav.animationFillMode,
    nav.animationTimingFunction,
  ]);

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (nav.backgroundImage && nav.backgroundImage.startsWith("./")) {
        const imageName = nav.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(nav.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [nav.backgroundImage, files]);

  const focusedStyles =
    isNavFocused && nav.pseudoClass === "focus"
      ? {
          width: nav.focusedwidth || nav.width || "100%",
          height: nav.focusedheight || nav.height || "auto",

          padding: nav.focusedpadding || nav.padding || "8px",
          paddingTop: nav.focusedpaddingTop || nav.focusedpadding || "8px",
          paddingRight: nav.focusedpaddingRight || nav.focusedpadding || "8px",
          paddingBottom:
            nav.focusedpaddingBottom || nav.focusedpadding || "8px",
          paddingLeft: nav.focusedpaddingLeft || nav.focusedpadding || "8px",
          margin: nav.focusedmargin || nav.margin || "0px",
          marginTop: nav.focusedmarginTop || nav.focusedmargin || "0px",
          marginRight: nav.focusedmarginRight || nav.focusedmargin || "0px",
          marginBottom: nav.focusedmarginBottom || nav.focusedmargin || "0px",
          marginLeft: nav.focusedmarginLeft || nav.focusedmargin || "0px",

          borderTop:
            nav.focusedborderTop ||
            nav.focusedborder ||
            nav.border ||
            "1px solid black",
          borderRight:
            nav.focusedborderRight ||
            nav.focusedborder ||
            nav.border ||
            "1px solid black",
          borderBottom:
            nav.focusedborderBottom ||
            nav.focusedborder ||
            nav.border ||
            "1px solid black",
          borderLeft:
            nav.focusedborderLeft ||
            nav.focusedborder ||
            nav.border ||
            "1px solid black",
          borderSapcing: nav.focusedborderSpacing || nav.borderSpacing || "0px",
          borderCollapse:
            nav.focusedborderCollapse || nav.borderCollapse || "0px",
          borderRadius: nav.focusedborderRadius || nav.borderRadius || "0",
          outline: nav.focusedoutline || nav.outline || "none",

          position: nav.focusedposition || nav.position || "relative",
          top: nav.focusedtop || nav.top || "auto",
          right: nav.focusedright || nav.right || "auto",
          bottom: nav.focusedbottom || nav.bottom || "auto",
          left: nav.focusedleft || nav.left || "auto",
          zIndex: nav.focusedzIndex || nav.zIndex || "auto",
          boxShadow: nav.focusedboxShadow || nav.boxShadow || "none",
          opacity: nav.focusedOpacity || nav.opacity || 1,
          display: nav.focuseddisplay || nav.display || "block",
          flexDirection:
            nav.focusedflexDirection || nav.flexDirection || "column",
          flexWrap: nav.focusedflexWrap || "nowrap",
          order: nav.focusedorder || "0",
          flexGrow: nav.focusedflexGrow || "0",
          flexShrink: nav.focusedflexShrink || "1",
          flexBasis: nav.focusedflexBasis || "auto",

          gridTemplateColumns: nav.focusedgridTemplateColumns || "none",
          gridTemplateRows: nav.focusedgridTemplateRows || "none",
          gridArea: nav.focusedgridArea || "auto",
          gridAutoFlow: nav.focusedgridAutoFlow || "row",
          gridAutoColumns: nav.focusedgridAutoColumns || "auto",
          gridAutoRows: nav.focusedgridAutoRows || "auto",
          columnGap: nav.focusedcolumnGap || "0",
          rowGap: nav.focusedrowGap || "0",

          justifyContent: nav.focusedjustifyContent || "flex-start",
          alignItems: nav.focusedalignItems || "stretch",
          alignContent: nav.focusedalignContent || "stretch",
          alignSelf: nav.focusedalignSelf || "auto",
          // placeContent: nav.focusedplaceContent || "normal",
          // placeItems: nav.focusedplaceItems || "normal",
          justifyItems: nav.focusedjustifyItems || "stretch",
          justifySelf: nav.focusedjustifySelf || "auto",

          gap: nav.focusedgap || "0",
          visibility: nav.focusedvisibility || "visible",

          color: nav.focusedcolor || nav.color || "#000000",
          backgroundColor:
            nav.focusedbackgroundColor || nav.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (nav.focusedbackgroundImage) {
              if (nav.focusedbackgroundImage.startsWith("./")) {
                const imageName = nav.focusedbackgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${nav.focusedbackgroundImage})`;
            }
            if (nav.backgroundImage) {
              if (nav.backgroundImage.startsWith("./")) {
                const imageName = nav.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${nav.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            nav.focusedbackgroundPosition || nav.backgroundPosition || "0% 0%",
          backgroundSize:
            nav.focusedbackgroundSize || nav.backgroundSize || "auto",
          backgroundRepeat:
            nav.focusedbackgroundRepeat || nav.backgroundRepeat || "repeat",
          backgroundAttachment:
            nav.focusedbackgroundAttachment ||
            nav.backgroundAttachment ||
            "scroll",

          fontFamily: nav.focusedfontFamily || nav.fontFamily || "inherit",
          fontSize: nav.focusedfontSize || nav.fontSize || "inherit",
          fontWeight: nav.focusedfontWeight || nav.fontWeight || "normal",
          fontStyle: nav.focusedfontStyle || nav.fontStyle || "normal",
          fontVariant: nav.focusedfontVariant || nav.fontVariant || "normal",
          lineHeight: nav.focusedlineHeight || nav.lineHeight || "normal",
          textShadow: nav.focusedtextShadow || nav.textShadow || "none",
          textAlign: nav.focusedtextAlign || nav.textAlign || "left",
          verticalAlign:
            nav.focusedverticalAlign || nav.verticalAlign || "baseline",
          textDecoration:
            nav.focusedtextDecoration || nav.textDecoration || "none",
          textTransform:
            nav.focusedtextTransform || nav.textTransform || "none",
          letterSpacing:
            nav.focusedletterSpacing || nav.letterSpacing || "normal",
          wordSpacing: nav.focusedwordSpacing || nav.wordSpacing || "normal",
          textIndent: nav.focusedtextIndent || nav.textIndent || "0",
          whiteSpace: nav.focusedwhiteSpace || nav.whiteSpace || "normal",
          textOverflow: nav.focusedtextOverflow || nav.textOverflow || "clip",
          direction: nav.focuseddirection || nav.direction || "ltr",
          unicodeBidi: nav.focusedunicodeBidi || nav.unicodeBidi || "normal",
          writingMode:
            nav.focusedwritingMode || nav.writingMode || "horizontal-tb",

          cursor: nav.focusedcursor || nav.cursor || "default",
          filter: nav.focusedfilter || nav.filter || "none",
          backdropFilter:
            nav.focusedbackdropFilter || nav.backdropFilter || "none",
          mixBlendMode: nav.focusedmixBlendMode || nav.mixBlendMode || "normal",
          aspectRatio: nav.focusedaspectRatio || nav.aspectRatio || "auto",

          transform: nav.focusedtransform || nav.transform || "none",
          transition: nav.focusedtransition || nav.transition || "none",
        }
      : {};

  const hoverStyles =
    isNavHovered && nav.pseudoClass === "hover"
      ? {
          width: nav.hoveredwidth || nav.width || "100%",
          height: nav.hoveredheight || nav.height || "auto",

          padding: nav.hoveredpadding || nav.padding || "8px",
          paddingTop: nav.hoveredpaddingTop || nav.hoveredpadding || "8px",
          paddingRight: nav.hoveredpaddingRight || nav.hoveredpadding || "8px",
          paddingBottom:
            nav.hoveredpaddingBottom || nav.hoveredpadding || "8px",
          paddingLeft: nav.hoveredpaddingLeft || nav.hoveredpadding || "8px",
          margin: nav.hoveredmargin || nav.margin || "0px",
          marginTop: nav.hoveredmarginTop || nav.hoveredmargin || "0px",
          marginRight: nav.hoveredmarginRight || nav.hoveredmargin || "0px",
          marginBottom: nav.hoveredmarginBottom || nav.hoveredmargin || "0px",
          marginLeft: nav.hoveredmarginLeft || nav.hoveredmargin || "0px",

          borderTop:
            nav.hoveredborderTop ||
            nav.hoveredborder ||
            nav.border ||
            "1px solid black",
          borderRight:
            nav.hoveredborderRight ||
            nav.hoveredborder ||
            nav.border ||
            "1px solid black",
          borderBottom:
            nav.hoveredborderBottom ||
            nav.hoveredborder ||
            nav.border ||
            "1px solid black",
          borderLeft:
            nav.hoveredborderLeft ||
            nav.hoveredborder ||
            nav.border ||
            "1px solid black",
          borderSapcing: nav.hoveredborderSpacing || nav.borderSpacing || "0px",
          borderCollapse:
            nav.hoveredborderCollapse || nav.borderCollapse || "0px",
          borderRadius: nav.hoveredborderRadius || nav.borderRadius || "0",
          outline: nav.hoveredoutline || nav.outline || "none",

          position: nav.hoveredposition || nav.position || "relative",
          top: nav.hoveredtop || nav.top || "auto",
          right: nav.hoveredright || nav.right || "auto",
          bottom: nav.hoveredbottom || nav.bottom || "auto",
          left: nav.hoveredleft || nav.left || "auto",
          zIndex: nav.hoveredzIndex || nav.zIndex || "auto",
          boxShadow: nav.hoveredboxShadow || nav.boxShadow || "none",
          opacity: nav.hoveredOpacity || nav.opacity || 1,
          display: nav.hovereddisplay || nav.display || "block",
          flexDirection:
            nav.hoveredflexDirection || nav.flexDirection || "column",
          flexWrap: nav.hoveredflexWrap || "nowrap",
          order: nav.hoveredorder || "0",
          flexGrow: nav.hoveredflexGrow || "0",
          flexShrink: nav.hoveredflexShrink || "1",
          flexBasis: nav.hoveredflexBasis || "auto",

          gridTemplateColumns: nav.hoveredgridTemplateColumns || "none",
          gridTemplateRows: nav.hoveredgridTemplateRows || "none",
          gridArea: nav.hoveredgridArea || "auto",
          gridAutoFlow: nav.hoveredgridAutoFlow || "row",
          gridAutoColumns: nav.hoveredgridAutoColumns || "auto",
          gridAutoRows: nav.hoveredgridAutoRows || "auto",
          columnGap: nav.hoveredcolumnGap || "0",
          rowGap: nav.hoveredrowGap || "0",

          justifyContent: nav.hoveredjustifyContent || "flex-start",
          alignItems: nav.hoveredalignItems || "stretch",
          alignContent: nav.hoveredalignContent || "stretch",
          alignSelf: nav.hoveredalignSelf || "auto",
          // placeContent: nav.hoveredplaceContent || "normal",
          // placeItems: nav.hoveredplaceItems || "normal",
          justifyItems: nav.hoveredjustifyItems || "stretch",
          justifySelf: nav.hoveredjustifySelf || "auto",

          gap: nav.hoveredgap || "0",
          visibility: nav.hoveredvisibility || "visible",

          color: nav.hoveredcolor || nav.color || "#000000",
          backgroundColor:
            nav.hoveredbackgroundColor || nav.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (nav.hoveredbackgroundImage) {
              if (nav.hoveredbackgroundImage.startsWith("./")) {
                const imageName = nav.hoveredbackgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${nav.hoveredbackgroundImage})`;
            }
            if (nav.backgroundImage) {
              if (nav.backgroundImage.startsWith("./")) {
                const imageName = nav.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${nav.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            nav.hoveredbackgroundPosition || nav.backgroundPosition || "0% 0%",
          backgroundSize:
            nav.hoveredbackgroundSize || nav.backgroundSize || "auto",
          backgroundRepeat:
            nav.hoveredbackgroundRepeat || nav.backgroundRepeat || "repeat",
          backgroundAttachment:
            nav.hoveredbackgroundAttachment ||
            nav.backgroundAttachment ||
            "scroll",

          fontFamily: nav.hoveredfontFamily || nav.fontFamily || "inherit",
          fontSize: nav.hoveredfontSize || nav.fontSize || "inherit",
          fontWeight: nav.hoveredfontWeight || nav.fontWeight || "normal",
          fontStyle: nav.hoveredfontStyle || nav.fontStyle || "normal",
          fontVariant: nav.hoveredfontVariant || nav.fontVariant || "normal",
          lineHeight: nav.hoveredlineHeight || nav.lineHeight || "normal",
          textShadow: nav.hoveredtextShadow || nav.textShadow || "none",
          textAlign: nav.hoveredtextAlign || nav.textAlign || "left",
          verticalAlign:
            nav.hoveredverticalAlign || nav.verticalAlign || "baseline",
          textDecoration:
            nav.hoveredtextDecoration || nav.textDecoration || "none",
          textTransform:
            nav.hoveredtextTransform || nav.textTransform || "none",
          letterSpacing:
            nav.hoveredletterSpacing || nav.letterSpacing || "normal",
          wordSpacing: nav.hoveredwordSpacing || nav.wordSpacing || "normal",
          textIndent: nav.hoveredtextIndent || nav.textIndent || "0",
          whiteSpace: nav.hoveredwhiteSpace || nav.whiteSpace || "normal",
          textOverflow: nav.hoveredtextOverflow || nav.textOverflow || "clip",
          direction: nav.hovereddirection || nav.direction || "ltr",
          unicodeBidi: nav.hoveredunicodeBidi || nav.unicodeBidi || "normal",
          writingMode:
            nav.hoveredwritingMode || nav.writingMode || "horizontal-tb",

          cursor: nav.hoveredcursor || nav.cursor || "default",
          filter: nav.hoveredfilter || nav.filter || "none",
          backdropFilter:
            nav.hoveredbackdropFilter || nav.backdropFilter || "none",
          mixBlendMode: nav.hoveredmixBlendMode || nav.mixBlendMode || "normal",
          aspectRatio: nav.hoveredaspectRatio || nav.aspectRatio || "auto",

          transform: nav.hoveredtransform || nav.transform || "none",
          transition: nav.hoveredtransition || nav.transition || "none",
        }
      : {};

  const activeStyles =
    isNavActive && nav.pseudoClass === "active"
      ? {
          width: nav.activatedwidth || nav.width || "100%",
          height: nav.hoveredheight || nav.height || "auto",

          padding: nav.activatedpadding || nav.padding || "8px",
          paddingTop: nav.activatedpaddingTop || nav.activatedpadding || "8px",
          paddingRight:
            nav.activatedpaddingRight || nav.activatedpadding || "8px",
          paddingBottom:
            nav.activatedpaddingBottom || nav.activatedpadding || "8px",
          paddingLeft:
            nav.activatedpaddingLeft || nav.activatedpadding || "8px",
          margin: nav.activatedmargin || nav.margin || "0px",
          marginTop: nav.activatedmarginTop || nav.activatedmargin || "0px",
          marginRight: nav.activatedmarginRight || nav.activatedmargin || "0px",
          marginBottom:
            nav.activatedmarginBottom || nav.activatedmargin || "0px",
          marginLeft: nav.activatedmarginLeft || nav.activatedmargin || "0px",

          borderTop:
            nav.activatedborderTop ||
            nav.activatedborder ||
            nav.border ||
            "1px solid black",
          borderRight:
            nav.activatedborderRight ||
            nav.activatedborder ||
            nav.border ||
            "1px solid black",
          borderBottom:
            nav.activatedborderBottom ||
            nav.activatedborder ||
            nav.border ||
            "1px solid black",
          borderLeft:
            nav.activatedborderLeft ||
            nav.activatedborder ||
            nav.border ||
            "1px solid black",
          borderSapcing:
            nav.activatedborderSpacing || nav.borderSpacing || "0px",
          borderCollapse:
            nav.activatedborderCollapse || nav.borderCollapse || "0px",
          borderRadius: nav.activatedborderRadius || nav.borderRadius || "0",
          outline: nav.activatedoutline || nav.outline || "none",

          position: nav.activatedposition || nav.position || "relative",
          top: nav.activatedtop || nav.top || "auto",
          right: nav.activatedright || nav.right || "auto",
          bottom: nav.activatedbottom || nav.bottom || "auto",
          left: nav.activatedleft || nav.left || "auto",
          zIndex: nav.activatedzIndex || nav.zIndex || "auto",

          boxShadow: nav.activatedboxShadow || nav.boxShadow || "none",
          opacity: nav.activatedOpacity || nav.opacity || 1,
          display: nav.activateddisplay || nav.display || "block",
          flexDirection:
            nav.activatedflexDirection || nav.flexDirection || "column",
          flexWrap: nav.activatedflexWrap || "nowrap",
          order: nav.activatedorder || "0",
          flexGrow: nav.activatedflexGrow || "0",
          flexShrink: nav.activatedflexShrink || "1",
          flexBasis: nav.activatedflexBasis || "auto",

          gridTemplateColumns: nav.activatedgridTemplateColumns || "none",
          gridTemplateRows: nav.activatedgridTemplateRows || "none",
          gridArea: nav.activatedgridArea || "auto",
          gridAutoFlow: nav.activatedgridAutoFlow || "row",
          gridAutoColumns: nav.activatedgridAutoColumns || "auto",
          gridAutoRows: nav.activatedgridAutoRows || "auto",
          columnGap: nav.activatedcolumnGap || "0",
          rowGap: nav.activatedrowGap || "0",

          justifyContent: nav.activatedjustifyContent || "flex-start",
          alignItems: nav.activatedalignItems || "stretch",
          alignContent: nav.activatedalignContent || "stretch",
          alignSelf: nav.activatedalignSelf || "auto",
          // placeContent: nav.activatedplaceContent || "normal",
          // placeItems: nav.activatedplaceItems || "normal",
          justifyItems: nav.activatedjustifyItems || "stretch",
          justifySelf: nav.activatedjustifySelf || "auto",

          gap: nav.activatedgap || "0",
          visibility: nav.activatedvisibility || "visible",

          color: nav.activatedcolor || nav.color || "#000000",
          backgroundColor:
            nav.activatedbackgroundColor || nav.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (nav.activatedbackgroundImage) {
              if (nav.activatedbackgroundImage.startsWith("./")) {
                const imageName = nav.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${nav.activatedbackgroundImage})`;
            }
            if (nav.backgroundImage) {
              if (nav.backgroundImage.startsWith("./")) {
                const imageName = nav.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${nav.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            nav.activatedbackgroundPosition ||
            nav.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            nav.activatedbackgroundSize || nav.backgroundSize || "auto",
          backgroundRepeat:
            nav.activatedbackgroundRepeat || nav.backgroundRepeat || "repeat",
          backgroundAttachment:
            nav.activatedbackgroundAttachment ||
            nav.backgroundAttachment ||
            "scroll",

          fontFamily: nav.activatedfontFamily || nav.fontFamily || "inherit",
          fontSize: nav.activatedfontSize || nav.fontSize || "inherit",
          fontWeight: nav.activatedfontWeight || nav.fontWeight || "normal",
          fontStyle: nav.activatedfontStyle || nav.fontStyle || "normal",
          fontVariant: nav.activatedfontVariant || nav.fontVariant || "normal",
          lineHeight: nav.activatedlineHeight || nav.lineHeight || "normal",
          textShadow: nav.activatedtextShadow || nav.textShadow || "none",
          textAlign: nav.activatedtextAlign || nav.textAlign || "left",
          verticalAlign:
            nav.activatedverticalAlign || nav.verticalAlign || "baseline",
          textDecoration:
            nav.activatedtextDecoration || nav.textDecoration || "none",
          textTransform:
            nav.activatedtextTransform || nav.textTransform || "none",
          letterSpacing:
            nav.activatedletterSpacing || nav.letterSpacing || "normal",
          wordSpacing: nav.activatedwordSpacing || nav.wordSpacing || "normal",
          textIndent: nav.activatedtextIndent || nav.textIndent || "0",
          whiteSpace: nav.activatedwhiteSpace || nav.whiteSpace || "normal",
          textOverflow: nav.activatedtextOverflow || nav.textOverflow || "clip",
          direction: nav.activateddirection || nav.direction || "ltr",
          unicodeBidi: nav.activatedunicodeBidi || nav.unicodeBidi || "normal",
          writingMode:
            nav.activatedwritingMode || nav.writingMode || "horizontal-tb",

          cursor: nav.activatedcursor || nav.cursor || "default",
          filter: nav.activatedfilter || nav.filter || "none",
          backdropFilter:
            nav.activatedbackdropFilter || nav.backdropFilter || "none",
          mixBlendMode:
            nav.activatedmixBlendMode || nav.mixBlendMode || "normal",
          aspectRatio: nav.activatedaspectRatio || nav.aspectRatio || "auto",

          transform: nav.activatedtransform || nav.transform || "none",
          transition: nav.activatedtransition || nav.transition || "none",
        }
      : {};

  const navStyle = {
    width: nav.width || "100%",
    height: nav.height || "auto",
    padding: nav.padding || "8px",
    paddingTop: nav.paddingTop || nav.padding || "8px",
    paddingRight: nav.paddingRight || nav.padding || "8px",
    paddingBottom: nav.paddingBottom || nav.padding || "8px",
    paddingLeft: nav.paddingLeft || nav.padding || "8px",
    margin: nav.margin || "0px",
    marginTop: nav.marginTop || nav.margin || "0px",
    marginRight: nav.marginRight || nav.margin || "0px",
    marginBottom: nav.marginBottom || nav.margin || "0px",
    marginLeft: nav.marginLeft || nav.margin || "0px",

    borderTop: nav.borderTop || nav.border || "1px solid #000000",
    borderRight: nav.borderRight || nav.border || "1px solid #000000",
    borderBottom: nav.borderBottom || nav.border || "1px solid #000000",
    borderLeft: nav.borderLeft || nav.border || "1px solid #000000",

    borderSapcing: nav.borderSpacing || "0px",
    borderCollapse: nav.borderCollapse || "0px",
    borderRadius: nav.borderRadius || "0",
    boxSizing: nav.boxSizing || "border-box",

    position: nav.position || "relative",
    top: nav.top || "auto",
    right: nav.right || "auto",
    bottom: nav.bottom || "auto",
    left: nav.left || "auto",
    zIndex: nav.zIndex || "auto",

    display: nav.display || "block",
    flexDirection: nav.flexDirection || "column",
    flexWrap: nav.flexWrap || "nowrap",
    order: nav.order || "0",
    flexGrow: nav.flexGrow || "0",
    flexShrink: nav.flexShrink || "1",
    flexBasis: nav.flexBasis || "auto",

    gridTemplateColumns: nav.gridTemplateColumns || "none",
    gridTemplateRows: nav.gridTemplateRows || "none",
    gridArea: nav.gridArea || "auto",
    gridAutoFlow: nav.gridAutoFlow || "row",
    gridAutoColumns: nav.gridAutoColumns || "auto",
    gridAutoRows: nav.gridAutoRows || "auto",
    columnGap: nav.columnGap || "0",
    rowGap: nav.rowGap || "0",

    justifyContent: nav.justifyContent || "flex-start",
    alignItems: nav.alignItems || "stretch",
    alignContent: nav.alignContent || "stretch",
    alignSelf: nav.alignSelf || "auto",
    // placeContent: nav.placeContent || "normal",
    // placeItems: nav.placeItems || "normal",
    justifyItems: nav.justifyItems || "stretch",
    justifySelf: nav.justifySelf || "auto",

    gap: nav.gap || "0",
    visibility: nav.visibility || "visible",

    color: nav.color || "#000000",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),

    backgroundPosition: nav.backgroundPosition || "0% 0%",
    backgroundSize: nav.backgroundSize || "auto",
    backgroundRepeat: nav.backgroundRepeat || "repeat",
    backgroundAttachment: nav.backgroundAttachment || "scroll",
    boxShadow: nav.boxShadow || "none",
    filter: nav.filter || "none",
    backdropFilter: nav.backdropFilter || "none",
    mixBlendMode: nav.mixBlendMode || "normal",
    aspectRatio: nav.aspectRatio || "auto",

    resize: nav.resize || "none",
    userSelect: nav.userSelect || "auto",
    overflow: nav.resize && nav.resize !== "none" ? "auto" : "visible",
    overflowX: nav.overflowX || "hidden",
    overflowY: nav.overflowY || "hidden",

    fontSize: nav.fontSize || "inherit",
    fontFamily: nav.fontFamily || "inherit",
    fontWeight: nav.fontWeight || "normal",
    fontStyle: nav.fontStyle || "normal",
    fontVariant: nav.fontVariant || "normal",
    lineHeight: nav.lineHeight || "normal",
    textAlign: nav.textAlign || "left",
    textDecoration: nav.textDecoration || "none",
    textTransform: nav.textTransform || "none",
    textShadow: nav.textShadow || "none",
    verticalAlign: nav.verticalAlign || "baseline",
    letterSpacing: nav.letterSpacing || "normal",
    wordSpacing: nav.wordSpacing || "normal",
    textIndent: nav.textIndent || "0",
    whiteSpace: nav.whiteSpace || "normal",
    textOverflow: nav.textOverflow || "clip",
    direction: nav.direction || "ltr",
    unicodeBidi: nav.unicodeBidi || "normal",
    writingMode: nav.writingMode || "horizontal-tb",
    cursor: nav.cursor || "default",
    outline: nav.outline || "none",

    backgroundColor: isHovered ? "#ADD8E6" : nav.backgroundColor || "#ffffff",


    listStyleType: nav.listStyleType || "disc",
    listStyleImage: nav.listStyleImage ? `url(${nav.listStyleImage})` : "none",
    listStylePosition: nav.listStylePosition || "outside",

    transform: nav.transform || "none",
    transition:
      nav.transition || "transform 0.3s ease, background-color 0.3s ease",

    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const [, drop] = useDrop({
    accept: [
      "DroppableDiv",
      "DroppableButton",
      "DroppableImage",
      "DroppableHeading",
      "DroppableParagraph",
      "DroppableIcon",
      "DroppableLink",
      "DroppableCheckbox",
      "DroppableRadio",
      "DroppableList",
      "DroppableTable",
      "DroppableVideo",
      "DroppableAudio",
      "DroppableTextInput",
      "DroppableRangeInput",
      "DroppablePasswordInput",
      "DroppableEmailInput",
      "DroppableNumberInput",
      "DroppableDateInput",
      "DroppableColorInput",
      "DroppableFileInput",
      "DroppableDropDown",
      "DroppableMap",
      "DroppableNav",
      "DroppableHeader",
      "DroppableHGroup",
      "DroppableFooter",
      "DroppableSection",
      "DroppableSpan",
      "DroppableForm",
      "DroppableMain",
      "DroppableArticle",
      "DroppableAside",
      "DroppableHorizontalRule",
      "DroppableLineBreak",
      "DroppableIframe",
    ],
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        if (item.type === "DroppableDiv") {
          addDivision(nav.id, item.name, item.type);
        } else if (
          item.type === "DroppableNav" ||
          item.type === "DroppableHeader" ||
          item.type === "DroppableHGroup" ||
          item.type === "DroppableFooter" ||
          item.type === "DroppableSection" ||
          item.type === "DroppableSpan" ||
          item.type === "DroppableForm" ||
          item.type === "DroppableMain" ||
          item.type === "DroppableArticle" ||
          item.type === "DroppableAside"
        ) {
          addCanvasDrop(nav.id, item.name, item.type);
        } else {
          addElement(nav.id, item.name, item.type);
        }
      }
    },
  });

  const combinedRef = useMemo(
    () => (node) => {
      NavRef.current = node;
      drop(node);
    },
    [drop]
  );

  return (
    <nav
      ref={combinedRef}
      style={navStyle}
      onMouseEnter={() => setIsNavHovered(true)}
      onMouseLeave={() => setIsNavHovered(false)}
      onFocus={() => setIsNavFocused(true)}
      onBlur={() => setIsNavFocused(false)}
      onMouseDown={() => setIsNavActive(true)}
      onMouseUp={() => setIsNavActive(false)}
      tabIndex={0}
    >
      {nav.children &&
        nav.children.map((child) => {
          switch (child.name) {
            case "Button":
              return <ButtonComponent key={child.id} button={child} />;
            case "Image":
              return <ImageComponent key={child.id} image={child} />;
            case "Heading":
              return <HeaderComponent key={child.id} header={child} />;
            case "Paragraph":
              return <ParagraphComponent key={child.id} paragraph={child} />;
            case "Icon":
              return <IconComponent key={child.id} icon={child} />;
            case "Link":
              return <LinkComponent key={child.id} link={child} />;
            case "Checkbox":
              return <CheckboxComponent key={child.id} checkbox={child} />;
            case "Radio":
              return <RadioComponent key={child.id} radio={child} />;
            case "List":
              return <ListComponent key={child.id} list={child} />;
            case "Table":
              return <TableComponent key={child.id} table={child} />;
            case "Video":
              return <VideoComponent key={child.id} video={child} />;
            case "Text":
              return <TextInputComponent key={child.id} textInput={child} />;
            case "Range":
              return <RangeComponent key={child.id} range={child} />;
            case "Password":
              return (
                <PasswordInputComponent key={child.id} passwordInput={child} />
              );
            case "Email":
              return <EmailInputComponent key={child.id} emailInput={child} />;
            case "Number":
              return (
                <NumberInputComponent key={child.id} numberInput={child} />
              );
            case "Date":
              return <DateInputComponent key={child.id} dateInput={child} />;
            case "Color":
              return <ColorInputComponent key={child.id} colorInput={child} />;
            case "File":
              return <FileInputComponent key={child.id} fileInput={child} />;
            case "Audio":
              return <AudioComponent key={child.id} audio={child} />;
            case "DropDown":
              return <DropDownComponent key={child.id} dropdown={child} />;
            case "Output":
              return <OutputComponent key={child.id} output={child} />;
            case "Map":
              return <MapComponent key={child.id} map={child} />;
            case "Nav":
              return <Nav key={child.id} nav={child} />;
            case "Header":
              return <HeaderTag key={child.id} headertag={child} />;
            case "HGroup":
              return <Hgroup key={child.id} hgroup={child} />;
            case "Footer":
              return <Footer key={child.id} footer={child} />;
            case "Section":
              return <Section key={child.id} section={child} />;
            case "Span":
              return <Span key={child.id} span={child} />;
            case "Form":
              return <FormComponent key={child.id} form={child} />;
            case "Main":
              return <MainComponent key={child.id} main={child} />;
            case "Article":
              return <ArticleComponent key={child.id} article={child} />;
            case "Aside":
              return <AsideComponent key={child.id} aside={child} />;
            case "HorizontalRule":
              return <HRTag key={child.id} div={child} />;
            case "LineBreak":
              return <BRTag key={child.id} div={child} />;
            case "Iframe":
              return <IframeComponent key={child.id} div={child} />;
            default:
              return <Division key={child.id} div={child} />;
          }
        })}
    </nav>
  );
};

export default Nav;
